import React from 'react'
import { Navbar } from 'react-bootstrap'
import { useAppContext } from 'state/context'

export const UserHeaderDisplay = () => {
  const [{ user }] = useAppContext()
  const copy = `Signed in as: ${user.email}`
  return <Navbar.Text>{copy}</Navbar.Text>
}
